import additionalPriceInfo from './additional-price-info.vue.component';
import { onMounted, onBeforeUnmount, ref } from 'vue';
import {mediaQuery} from '../../scripts/lib/mediaQuery.js';

const templateElement = document.getElementById('ents-preisbereich-template');

export default {
  template: templateElement ? templateElement.innerHTML : '',

  components: {
    additionalPriceInfo,
  },

  props: {
    displayPrice: {
      type: Object,
      required: true,
    },
  },

  setup() {
    const isMobileViewport = ref(mediaQuery.up_to_L);
    const badgeSize = ref('l');

    const handleResize = () => {
      badgeSize.value = window.innerWidth < 960 ? 'm' : 'l';
    };

    onMounted(() => {
      handleResize();

      window.addEventListener('resize', handleResize);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', handleResize);
    });

    return {
      badgeSize,
      isMobileViewport
    };
  },

};
